export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    return;
  }
  // Section doesn't exist on this page (e.g. we're on /new-arrivals) —
  // go back to the homepage and land on that section.
  if (window.location.pathname !== "/") {
    window.location.href = id === "home" ? "/" : `/#${id}`;
  }
};
